import { useState } from "react";
import { ButtonPrimary } from "../../../components/NewButtons";
import { MutatePaymentProviderConfigurationDrawer } from "./MutatePaymentProviderConfigurationDrawer";

type Props = {
  existingPaymentProviders: string[];
};

export const MutatePaymentProviderConfigurationSelector = ({
  existingPaymentProviders,
}: Props) => {
  const [modalOpen, setModalOpen] = useState<boolean>(false);

  return (
    <div>
      <ButtonPrimary onClick={() => setModalOpen(true)} type="button">
        Create payment provider configuration
      </ButtonPrimary>
      <MutatePaymentProviderConfigurationDrawer
        existingPaymentProviders={existingPaymentProviders}
        isOpen={modalOpen}
        onClose={() => {
          setModalOpen(false);
        }}
      />
    </div>
  );
};
